module.exports = __webpack_public_path__ + "assets/c91f8bc18c6b0b23336d662d6ddb683d.svg";